import React from 'react';
import { ExpeditionLog } from '../../../../trailhead/ExpeditionLog';

export const HistoryTab: React.FC<{ sessionId: string; darkMode: boolean }> = ({ sessionId, darkMode }) => (
  <ExpeditionLog sessionId={sessionId} darkMode={darkMode} variant="embedded" />
);
